import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-no-match-financial-advisory',
    standalone: true,
    imports: [CommonModule, TranslateModule, MatIconModule],
    templateUrl: './no-match-financial-advisory.component.html',
    styleUrl: './no-match-financial-advisory.component.scss',
})
export class NoMatchFinancialAdvisoryComponent {
    @Input() caseId: any;
    @Input() isDisabled: boolean = false;
    @Input() isSelected: boolean = false;
    @Output() fASelect: EventEmitter<any> = new EventEmitter<any>();

    onSelectFA() {
        this.fASelect.emit(this.isSelected);
    }
}
